import { Colors, FlexBox } from '@helloself/hello-self-ui';

interface TileProps {
    children: React.ReactNode;
    background?: {
        backgroundColor: string;
        backgroundImage?: string;
    };
}

const Tile = ({ children, background = { backgroundColor: Colors.white } }: TileProps) => (
    <FlexBox
        width="100%"
        height="auto"
        padding="24px"
        borderRadius="8px"
        flexDirection="column"
        boxShadow="0px 4px 4px 0px rgba(38, 38, 38, 0.02)"
        backgroundRepeat="no-repeat"
        {...background}
    >
        {children}
    </FlexBox>
);

export default Tile;
